module.exports = __webpack_public_path__ + "img/contact_address.2c782ca8.jpg";